import React, { useEffect, useRef, useState } from "react";
import Header from "../../components/global/Header";
import LeftNavbar from "../../components/global/LeftNavbar";
import {  useTranslation } from 'react-i18next';
import Select from 'react-select';

export default function EloquaIntegration() {
    const scrollRef = useRef(null);
    const { t } = useTranslation();
    const translate = t;
    const showModel = () => {
     // setconditionalpopup(true);
      document.body.classList.add("modal-open");
    };
    const hideModel = () => {
      document.body.classList.remove("modal-open");
    };
    const showEditModel = () => {
      //setconditionalpopup(false);
      document.body.classList.add("modal-open");
    };
    const hideEditModel = () => {
      document.body.classList.remove("modal-open");
    };
    //const [conditionalpopup, setconditionalpopup] = useState(false);
    
  return (
    <div className="body bg-color">
      <div id="container" className="dashboard-wrapper">
        <Header ref={scrollRef} />
        <LeftNavbar />
        <section className="dashboard-content" ref={scrollRef} tabIndex={0}>
          <div id="content" className="dashboard-wrap">
            <nav className="breadcrumb" aria-label="breadcrumb">
              <ol>
                <li className="breadcrumb-item active" aria-current="page">
                  {translate("home")}
                </li>
              </ol>
            </nav>
             <div className="project-setting-page">
                <div className="project-heading userprofile-heading">
                    <div className="back-arrow flex-center">
                     <button aria-label="back">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13" fill="none">
                        <path d="M0.46967 5.96967C0.176777 6.26256 0.176777 6.73744 0.46967 7.03033L5.24264 11.8033C5.53553 12.0962 6.01041 12.0962 6.3033 11.8033C6.59619 11.5104 6.59619 11.0355 6.3033 10.7426L2.06066 6.5L6.3033 2.25736C6.59619 1.96447 6.59619 1.48959 6.3033 1.1967C6.01041 0.903806 5.53553 0.903806 5.24264 1.1967L0.46967 5.96967ZM1 7.25H14V5.75H1V7.25Z" fill="#1D4ED8"/>
                        </svg>
                     </button>
                     <span>Back to Settings</span>
                    </div>
                    <h3 className="flex">Eloqua Integration</h3>
                    <span>Browse, manage and send your Eloqua assets to translation.</span>
                 </div>
                <div className="white-bg"> 
                <div className="integration-tab-content marketo-integration-accordion">
                    <div className="integration-accordion-list open">
                      <div className="accordion-heading flex">
                        <div className="left">
                          <strong>User Permissions</strong>
                        </div>
                        <div className="right">
                           <svg className="plus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                             <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4"/>
                             <rect x="12.2773" y="6.5" width="1.44444" height="13" rx="0.722222" fill="#1D4ED8"/>
                             <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8"/>
                            </svg>
                            <svg className="minus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                             <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4"/>
                             <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8"/>
                            </svg>
                        </div>
                      </div>
                      <div className="integration-accordion-content">
                       <p>Manage who has permission to create Eloqua integration projects in OPAL-Marketing.</p>
                       <div className="table-responsive global-table">
                          <table className="sortable">
                            <thead>
                                <th>Name</th>
                                <th>Role</th>
                                <th>Department</th>
                                <th>Access to Eloqua</th>
                            </thead>
                            <tbody>
                                <tr>
                                  <td>App Stage Dev</td>
                                  <td>Administrator</td>
                                  <td>
                                    Anurag V Test Department, BDept, Depart_1
                                  <a href="#" onClick={showModel}> + 16</a>
                                  </td>
                                  <td>
                                    <div className="flex-center gap-10">
                                      <div className="yes-no-customradio">
                                        <input type="radio" className="form-check-input" name="radio1" id="rd1" checked />
                                        <label className="form-check-label" for="rd1">Yes</label>
                                      </div>
                                      <div className="yes-no-customradio">
                                        <input type="radio" className="form-check-input" name="radio1" id="rd2" />
                                        <label className="form-check-label" for="rd2">No</label>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td>Aditya MS</td>
                                  <td>Project Manager</td>
                                  <td>
                                    Anurag V Test Department, BDept, Depart_1
                                  <a href="#"> + 16</a>
                                  </td>
                                  <td>
                                    <div className="flex-center gap-10">
                                      <div className="yes-no-customradio">
                                        <input type="radio" className="form-check-input" name="radio2" id="rd3" />
                                        <label className="form-check-label" for="rd3">Yes</label>
                                      </div>
                                      <div className="yes-no-customradio">
                                        <input type="radio" className="form-check-input" name="radio2" id="rd4" checked />
                                        <label className="form-check-label" for="rd4">No</label>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td>App Stage Dev</td>
                                  <td>Administrator</td>
                                  <td>
                                    Anurag V Test Department, BDept, Depart_1
                                  <a href="#"> + 16</a>
                                  </td>
                                  <td>
                                    <div className="flex-center gap-10">
                                      <div className="yes-no-customradio">
                                        <input type="radio" className="form-check-input" name="radio3" id="rd5" />
                                        <label className="form-check-label" for="rd5">Yes</label>
                                      </div>
                                      <div className="yes-no-customradio">
                                        <input type="radio" className="form-check-input" name="radio3" id="rd6" checked />
                                        <label className="form-check-label" for="rd6">No</label>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                             </tbody>
                          </table>
                        </div>
                        {/* <div className="flex flex-end mar-top30">
                           <button className="blue-btn active">Save</button>
                        </div> */}
                      </div>
                    </div>
                    <div className="integration-accordion-list open">
                      <div className="accordion-heading flex">
                        <div className="left">
                          <strong>Department Settings</strong>
                        </div>
                        <div className="right">
                           <svg className="plus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                             <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4"/>
                             <rect x="12.2773" y="6.5" width="1.44444" height="13" rx="0.722222" fill="#1D4ED8"/>
                             <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8"/>
                            </svg>
                            <svg className="minus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                             <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4"/>
                             <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8"/>
                            </svg>
                        </div>
                      </div>
                      <div className="integration-accordion-content">
                       <div className="table-responsive global-table">
                          <table className="sortable">
                            <thead>
                                <th>Department</th>
                                <th>Default include dependencies checkbox behavior (on/off)</th>
                            </thead>
                            <tbody>
                                <tr>
                                  <td>Depart_1</td>
                                  <td>
                                    <div className="form-check">
                                      <input className="form-check-input" type="checkbox" name="checkbox" id="chk1" checked />
                                      <label className="form-check-label" aria-label="checkbox" for="chk1">&nbsp;</label>
                                    </div>
                                  </td>
                                </tr>
                           </tbody>
                          </table>
                        </div>
                        {/* <div className="flex flex-end mar-top30">
                           <button className="blue-btn active">Save</button>
                        </div> */}
                      </div>
                    </div>
                    <div className="integration-accordion-list open">
                      <div className="accordion-heading flex">
                        <div className="left">
                          <strong>Supported Image Formats</strong>
                        </div>
                        <div className="right">
                           <svg className="plus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                             <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4"/>
                             <rect x="12.2773" y="6.5" width="1.44444" height="13" rx="0.722222" fill="#1D4ED8"/>
                             <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8"/>
                            </svg>
                            <svg className="minus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                             <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4"/>
                             <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8"/>
                            </svg>
                        </div>
                      </div>
                      <div className="integration-accordion-content">
                         <p className="f14-para">Select which image formats are allowed as source files for Eloqua projects</p>
                         <div className="form-check small-checkbox">
                            <input className="form-check-input" type="checkbox" name="chkbox" id="chk222" />
                            <label className="form-check-label" for="chk222">Adobe Illustrator (.ai)</label>
                         </div>  
                         <div className="form-check small-checkbox">
                            <input className="form-check-input" type="checkbox" name="chkbox" id="chk223" checked />
                            <label className="form-check-label" for="chk223">Postscript/Encapsulated Postscript (.ps, .eps)</label>
                         </div> 
                         <div className="form-check small-checkbox">
                            <input className="form-check-input" type="checkbox" name="chkbox" id="chk224" checked />
                            <label className="form-check-label" for="chk224">Photoshop (.psd)</label>
                         </div> 
                         <div className="form-check small-checkbox">
                            <input className="form-check-input" type="checkbox" name="chkbox" id="chk225" checked />
                            <label className="form-check-label" for="chk225">Scalable Vector Graphics (.svg)</label>
                         </div> 
                      </div>
                    </div>

                    <div className="integration-accordion-list open">
                      <div className="accordion-heading flex">
                        <div className="left">
                          <strong>Configure Eloqua Email Header Footer Mapping</strong>
                        </div>
                        <div className="right">
                           <svg className="plus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                             <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4"/>
                             <rect x="12.2773" y="6.5" width="1.44444" height="13" rx="0.722222" fill="#1D4ED8"/>
                             <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8"/>
                            </svg>
                            <svg className="minus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                             <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4"/>
                             <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8"/>
                            </svg>
                        </div>
                      </div>
                      <div className="integration-accordion-content">
                         <p className="f14-para">
                           This configuration allows the appropriate headers and footers to be used when an email is translated.
                           <div><strong>Step 1:</strong> Select the source language header or footer.</div>
                           <div> <strong>Step 2:</strong> Select the header or footer for each target language.</div>
                         </p>
                         <p className="f14-para">
                          For example, lets say you have a English email with a footer containing your company address in US. If you need to translate this email in French but want the translated french email to use your company's address in France, then you need to map below the English email
                          footer containing US address to French email footer containing French address.
                         </p>
                         <div className="table-responsive global-table configure-eloqua">
                          <table className="sortable">
                            <thead>
                                <th>Asset Type</th>
                                <th>source language</th>
                                <th><div>Target Language</div></th>
                                <th>Action</th>
                            </thead>
                            <tbody>
                                <tr>
                                  <td>
                                    <div className="flex-center wrap-dropdown">
                                      <div className="global-dropdown-block mr-12">
                                         <Select classNamePrefix='cw'
                                          className="global-dropdown-select"
                                          defaultValue={{ label: 'Select Asset Type' }}
                                          />
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="flex-center wrap-dropdown">
                                      <div className="global-dropdown-block mr-12">
                                         <Select classNamePrefix='cw'
                                          className="global-dropdown-select"
                                          defaultValue={{ label: 'Select Source Language' }}
                                          />
                                      </div>
                                      <div className="flex-center">
                                        <div className="mr-12 select-lang">
                                          <a href="#"  onClick={showModel}>Select</a>
                                        </div>
                                        <button className="inline-flex" aria-label="delete">
                                          <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 21 21" fill="none">
                                            <path d="M17.9242 17.9242C15.94 19.9085 13.3062 21 10.5 21C7.69381 21 5.05997 19.9085 3.07576 17.9242C1.09154 15.94 0 13.3062 0 10.5C0 7.69381 1.09154 5.05997 3.07576 3.07576C5.05997 1.09154 7.69381 0 10.5 0C13.3062 0 15.94 1.09154 17.9242 3.07576C19.9085 5.05997 21 7.69381 21 10.5C21 13.3062 19.9085 15.94 17.9242 17.9242ZM17.0802 3.91982C15.3213 2.16098 12.9836 1.19318 10.5 1.19318C8.01641 1.19318 5.67866 2.16098 3.91982 3.91982C0.291667 7.54798 0.291667 13.452 3.91982 17.0802C5.67866 18.839 8.01641 19.8068 10.5 19.8068C12.9836 19.8068 15.3213 18.839 17.0802 17.0802C20.7083 13.452 20.7083 7.54798 17.0802 3.91982Z" fill="#1D4ED8"/>
                                            <path d="M15.1267 15.1271C14.8925 15.3613 14.5169 15.3613 14.2827 15.1271L10.4998 11.3442L6.71699 15.1271C6.48278 15.3613 6.10715 15.3613 5.87293 15.1271C5.63871 14.8929 5.63871 14.5172 5.87293 14.283L9.65576 10.5002L5.87293 6.71735C5.63871 6.48313 5.63871 6.1075 5.87293 5.87328C5.98783 5.75838 6.1425 5.69652 6.29275 5.69652C6.443 5.69652 6.59768 5.75397 6.71257 5.87328L10.4954 9.65611L14.2782 5.87328C14.3931 5.75838 14.5478 5.69652 14.6981 5.69652C14.8527 5.69652 15.003 5.75397 15.1179 5.87328C15.3521 6.1075 15.3521 6.48313 15.1179 6.71735L11.3439 10.5002L15.1267 14.283C15.3609 14.5172 15.3609 14.8929 15.1267 15.1271Z" fill="#1D4ED8"/>
                                          </svg>
                                        </button>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div>
                                       <button className="blue-btn active" aria-label="Delete Target Language">Add Target Language</button>

                                        <div className="flex-center wrap-dropdown mar-top15">
                                          <div className="global-dropdown-block mb-0 mr-12">
                                            <Select classNamePrefix='cw'
                                              className="global-dropdown-select"
                                              defaultValue={{ label: 'Select Asset Type' }}
                                              />
                                          </div>
                                          <div className="flex-center">
                                            <div className="mr-12 select-lang">
                                              <a href="#">Select</a>
                                            </div>
                                            <button className="inline-flex" aria-label="delete">
                                              <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 21 21" fill="none">
                                                <path d="M17.9242 17.9242C15.94 19.9085 13.3062 21 10.5 21C7.69381 21 5.05997 19.9085 3.07576 17.9242C1.09154 15.94 0 13.3062 0 10.5C0 7.69381 1.09154 5.05997 3.07576 3.07576C5.05997 1.09154 7.69381 0 10.5 0C13.3062 0 15.94 1.09154 17.9242 3.07576C19.9085 5.05997 21 7.69381 21 10.5C21 13.3062 19.9085 15.94 17.9242 17.9242ZM17.0802 3.91982C15.3213 2.16098 12.9836 1.19318 10.5 1.19318C8.01641 1.19318 5.67866 2.16098 3.91982 3.91982C0.291667 7.54798 0.291667 13.452 3.91982 17.0802C5.67866 18.839 8.01641 19.8068 10.5 19.8068C12.9836 19.8068 15.3213 18.839 17.0802 17.0802C20.7083 13.452 20.7083 7.54798 17.0802 3.91982Z" fill="#1D4ED8"/>
                                                <path d="M15.1267 15.1271C14.8925 15.3613 14.5169 15.3613 14.2827 15.1271L10.4998 11.3442L6.71699 15.1271C6.48278 15.3613 6.10715 15.3613 5.87293 15.1271C5.63871 14.8929 5.63871 14.5172 5.87293 14.283L9.65576 10.5002L5.87293 6.71735C5.63871 6.48313 5.63871 6.1075 5.87293 5.87328C5.98783 5.75838 6.1425 5.69652 6.29275 5.69652C6.443 5.69652 6.59768 5.75397 6.71257 5.87328L10.4954 9.65611L14.2782 5.87328C14.3931 5.75838 14.5478 5.69652 14.6981 5.69652C14.8527 5.69652 15.003 5.75397 15.1179 5.87328C15.3521 6.1075 15.3521 6.48313 15.1179 6.71735L11.3439 10.5002L15.1267 14.283C15.3609 14.5172 15.3609 14.8929 15.1267 15.1271Z" fill="#1D4ED8"/>
                                              </svg>
                                            </button>
                                          </div>
                                        </div>

                                        <div className="flex-center wrap-dropdown mar-top15">
                                          <div className="global-dropdown-block mb-0">
                                            <Select classNamePrefix='cw'
                                              className="global-dropdown-select"
                                              defaultValue={{ label: 'Select Asset Type' }}
                                              />
                                          </div>
                                        </div>
                                    </div>
                                  </td>
                                  <td>
                                   <button className="inline-flex">
                                    <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                      <path d="M17.9242 17.9242C15.94 19.9085 13.3062 21 10.5 21C7.69381 21 5.05997 19.9085 3.07576 17.9242C1.09154 15.94 0 13.3062 0 10.5C0 7.69381 1.09154 5.05997 3.07576 3.07576C5.05997 1.09154 7.69381 0 10.5 0C13.3062 0 15.94 1.09154 17.9242 3.07576C19.9085 5.05997 21 7.69381 21 10.5C21 13.3062 19.9085 15.94 17.9242 17.9242ZM17.0802 3.91982C15.3213 2.16098 12.9836 1.19318 10.5 1.19318C8.01641 1.19318 5.67866 2.16098 3.91982 3.91982C0.291667 7.54798 0.291667 13.452 3.91982 17.0802C5.67866 18.839 8.01641 19.8068 10.5 19.8068C12.9836 19.8068 15.3213 18.839 17.0802 17.0802C20.7083 13.452 20.7083 7.54798 17.0802 3.91982Z" fill="#1D4ED8"/>
                                      <path d="M15.1267 15.1271C14.8925 15.3613 14.5169 15.3613 14.2827 15.1271L10.4998 11.3442L6.71699 15.1271C6.48278 15.3613 6.10715 15.3613 5.87293 15.1271C5.63871 14.8929 5.63871 14.5172 5.87293 14.283L9.65576 10.5002L5.87293 6.71735C5.63871 6.48313 5.63871 6.1075 5.87293 5.87328C5.98783 5.75838 6.1425 5.69652 6.29275 5.69652C6.443 5.69652 6.59768 5.75397 6.71257 5.87328L10.4954 9.65611L14.2782 5.87328C14.3931 5.75838 14.5478 5.69652 14.6981 5.69652C14.8527 5.69652 15.003 5.75397 15.1179 5.87328C15.3521 6.1075 15.3521 6.48313 15.1179 6.71735L11.3439 10.5002L15.1267 14.283C15.3609 14.5172 15.3609 14.8929 15.1267 15.1271Z" fill="#1D4ED8"/>
                                    </svg>
                                   </button>
                                  </td>
                                </tr>

                                <tr>
                                  <td>
                                    <div className="flex-center wrap-dropdown">
                                      <div className="global-dropdown-block mr-12">
                                         <Select classNamePrefix='cw'
                                          className="global-dropdown-select"
                                          defaultValue={{ label: 'Select Asset Type' }}
                                          />
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="flex-center wrap-dropdown">
                                      <div className="global-dropdown-block mr-12">
                                         <Select classNamePrefix='cw'
                                          className="global-dropdown-select"
                                          defaultValue={{ label: 'Select Source Language' }}
                                          />
                                      </div>
                                      <div className="flex-center hidden-data">
                                        <div className="mr-12 select-lang">
                                          <a href="#">Select</a>
                                        </div>
                                        <button className="inline-flex" aria-label="delete">
                                          <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 21 21" fill="none">
                                            <path d="M17.9242 17.9242C15.94 19.9085 13.3062 21 10.5 21C7.69381 21 5.05997 19.9085 3.07576 17.9242C1.09154 15.94 0 13.3062 0 10.5C0 7.69381 1.09154 5.05997 3.07576 3.07576C5.05997 1.09154 7.69381 0 10.5 0C13.3062 0 15.94 1.09154 17.9242 3.07576C19.9085 5.05997 21 7.69381 21 10.5C21 13.3062 19.9085 15.94 17.9242 17.9242ZM17.0802 3.91982C15.3213 2.16098 12.9836 1.19318 10.5 1.19318C8.01641 1.19318 5.67866 2.16098 3.91982 3.91982C0.291667 7.54798 0.291667 13.452 3.91982 17.0802C5.67866 18.839 8.01641 19.8068 10.5 19.8068C12.9836 19.8068 15.3213 18.839 17.0802 17.0802C20.7083 13.452 20.7083 7.54798 17.0802 3.91982Z" fill="#1D4ED8"/>
                                            <path d="M15.1267 15.1271C14.8925 15.3613 14.5169 15.3613 14.2827 15.1271L10.4998 11.3442L6.71699 15.1271C6.48278 15.3613 6.10715 15.3613 5.87293 15.1271C5.63871 14.8929 5.63871 14.5172 5.87293 14.283L9.65576 10.5002L5.87293 6.71735C5.63871 6.48313 5.63871 6.1075 5.87293 5.87328C5.98783 5.75838 6.1425 5.69652 6.29275 5.69652C6.443 5.69652 6.59768 5.75397 6.71257 5.87328L10.4954 9.65611L14.2782 5.87328C14.3931 5.75838 14.5478 5.69652 14.6981 5.69652C14.8527 5.69652 15.003 5.75397 15.1179 5.87328C15.3521 6.1075 15.3521 6.48313 15.1179 6.71735L11.3439 10.5002L15.1267 14.283C15.3609 14.5172 15.3609 14.8929 15.1267 15.1271Z" fill="#1D4ED8"/>
                                          </svg>
                                        </button>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="hidden-data">
                                       <button className="blue-btn active" aria-label="Delete Target Language">Add Target Language</button>
                                     </div>
                                  </td>
                                  <td>
                                   <button className="inline-flex">
                                    <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                      <path d="M17.9242 17.9242C15.94 19.9085 13.3062 21 10.5 21C7.69381 21 5.05997 19.9085 3.07576 17.9242C1.09154 15.94 0 13.3062 0 10.5C0 7.69381 1.09154 5.05997 3.07576 3.07576C5.05997 1.09154 7.69381 0 10.5 0C13.3062 0 15.94 1.09154 17.9242 3.07576C19.9085 5.05997 21 7.69381 21 10.5C21 13.3062 19.9085 15.94 17.9242 17.9242ZM17.0802 3.91982C15.3213 2.16098 12.9836 1.19318 10.5 1.19318C8.01641 1.19318 5.67866 2.16098 3.91982 3.91982C0.291667 7.54798 0.291667 13.452 3.91982 17.0802C5.67866 18.839 8.01641 19.8068 10.5 19.8068C12.9836 19.8068 15.3213 18.839 17.0802 17.0802C20.7083 13.452 20.7083 7.54798 17.0802 3.91982Z" fill="#1D4ED8"/>
                                      <path d="M15.1267 15.1271C14.8925 15.3613 14.5169 15.3613 14.2827 15.1271L10.4998 11.3442L6.71699 15.1271C6.48278 15.3613 6.10715 15.3613 5.87293 15.1271C5.63871 14.8929 5.63871 14.5172 5.87293 14.283L9.65576 10.5002L5.87293 6.71735C5.63871 6.48313 5.63871 6.1075 5.87293 5.87328C5.98783 5.75838 6.1425 5.69652 6.29275 5.69652C6.443 5.69652 6.59768 5.75397 6.71257 5.87328L10.4954 9.65611L14.2782 5.87328C14.3931 5.75838 14.5478 5.69652 14.6981 5.69652C14.8527 5.69652 15.003 5.75397 15.1179 5.87328C15.3521 6.1075 15.3521 6.48313 15.1179 6.71735L11.3439 10.5002L15.1267 14.283C15.3609 14.5172 15.3609 14.8929 15.1267 15.1271Z" fill="#1D4ED8"/>
                                    </svg>
                                   </button>
                                  </td>
                                </tr>

                                <tr>
                                  <td colSpan="4">
                                    <div className="flex justify-end">
                                      <button className="blue-btn active" aria-label="Add Asset">Add Asset</button>
                                    </div>
                                  </td>
                                </tr>
                                
                           </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div> 
                </div>
             </div>
          </div>
        </section>
      </div>
       <div className="lightbox-panel sm-lg-lightbox-panel">
              <div className="inner-lightbox-panel pb-0">
              <div className="modal-header flex padd-lr">
                <strong>Eloqua Integration</strong>
                <button className="close" aria-label="close popup" onClick={hideEditModel}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none"><path d="M17.9242 17.9242C15.94 19.9085 13.3062 21 10.5 21C7.69381 21 5.05997 19.9085 3.07576 17.9242C1.09154 15.94 0 13.3062 0 10.5C0 7.69381 1.09154 5.05997 3.07576 3.07576C5.05997 1.09154 7.69381 0 10.5 0C13.3062 0 15.94 1.09154 17.9242 3.07576C19.9085 5.05997 21 7.69381 21 10.5C21 13.3062 19.9085 15.94 17.9242 17.9242ZM17.0802 3.91982C15.3213 2.16098 12.9836 1.19318 10.5 1.19318C8.01641 1.19318 5.67866 2.16098 3.91982 3.91982C0.291667 7.54798 0.291667 13.452 3.91982 17.0802C5.67866 18.839 8.01641 19.8068 10.5 19.8068C12.9836 19.8068 15.3213 18.839 17.0802 17.0802C20.7083 13.452 20.7083 7.54798 17.0802 3.91982Z" fill="white"></path><path d="M15.1267 15.1269C14.8925 15.3611 14.5169 15.3611 14.2827 15.1269L10.4998 11.3441L6.71699 15.1269C6.48278 15.3611 6.10715 15.3611 5.87293 15.1269C5.63871 14.8927 5.63871 14.517 5.87293 14.2828L9.65576 10.5L5.87293 6.71716C5.63871 6.48295 5.63871 6.10732 5.87293 5.8731C5.98783 5.7582 6.1425 5.69633 6.29275 5.69633C6.443 5.69633 6.59768 5.75378 6.71257 5.8731L10.4954 9.65593L14.2782 5.8731C14.3931 5.7582 14.5478 5.69633 14.6981 5.69633C14.8527 5.69633 15.003 5.75378 15.1179 5.8731C15.3521 6.10732 15.3521 6.48295 15.1179 6.71716L11.3439 10.5L15.1267 14.2828C15.3609 14.517 15.3609 14.8927 15.1267 15.1269Z" fill="white"></path></svg>
                </button>
              </div>
              <div className="lightbox-content padd-22">
                 <p>Manage your Eloqua login credentials for Eloqua Integration projects.</p>
                 <div className="flex">
                  <div className="leftBlock">
                     <p>Please log in to your Eloqua account to access your marketing assets through OPAL-Marketing.</p>
                     <p>Once you have logged in, you will be able to see all of your Eloqua assets and automate their translation.</p>
                     <p><a href="#">Learn More about Eloqua Integration</a></p>
                  </div>
                  <div className="rightBlock">
                    <div className="flex wrap-dropdown flex-column mb-0">
                       <div className="global-dropdown-block mr-0">
					                <label>Company Name</label>
                          <div className="global-dropdown-select">
                            <input type="text" className="form-control-sm" title="Company Name" />                            
                          </div>
				             	 </div>
                        <div className="global-dropdown-block mr-0">
					                <label>Your Eloqua username</label>
                          <div className="global-dropdown-select">
                            <input type="text" className="form-control-sm" title="Your Eloqua username" />                            
                          </div>
				             	 </div>
                        <div className="global-dropdown-block mr-0">
					                <label>Your Eloqua password</label>
                          <div className="global-dropdown-select">
                            <input type="text" className="form-control-sm" title="Your Eloqua password" />                            
                          </div>
				             	 </div>
                      </div>
                  </div>
                  
                 </div>
              </div>	
              <div className="modal-footer modal-footer-border flex px-22">
                    <button className="btn btn-bold" onClick={hideEditModel}>Cancel</button>
                    <button className="btn btn-bold active">Save</button>
                </div>
              </div>		
        </div>
       
        <div className="stricy-btn flex flex-center no-rightlist justify-end">
        <div className="left flex">
            <div>
             <button className="btn-default">Cancel</button>
            </div>
            <div>
            <button className="btn-default">Save</button>
            </div>
        </div>
     </div>
    </div>
  );
}
